import axios from 'axios';
import { getItem } from '../utils/localStorage';

export const updateProfilePic = async (formData) => {
    const {accessToken, user, userProfile } = getItem('user');
    return axios.post(`${Env.API_URL}/user-profile/${userProfile.id || user.id}/attachFile`, formData,
    {
      headers: {
        Authorization : `Bearer ${accessToken}`,
      },
    });
  };

export const getProfilePic = async () => {
    const {accessToken, user, userProfile} = getItem('user');
    const res = userProfile && await  axios.get(`${Env.API_URL}/user-profile/${userProfile.id || user.id}/profile/getAttachFile`,
    {
      headers: {
        Authorization : `Bearer ${accessToken}`,
      },
    });
    return res && res.data;
  };

export const deleteProfilePic = async (id) => {
    const {accessToken} = getItem('user');
    const {data} = await axios.delete(`${Env.API_URL}/user-profile/${id}/deleteAttachFile`,
    {
      headers: {
        Authorization : `Bearer ${accessToken}`,
      },
    });
    return data;
  };
export const setProfilePoint = async (elearningData) => {
    const {accessToken} = getItem('user');
    const {data} = await axios.put(`${Env.API_URL}/profile-point`, elearningData,
    {
      headers: {
        Authorization : `Bearer ${accessToken}`,
      },
    });
    return data;
  };
export const getAchivmentMonthly = async () => {
    const {accessToken} = getItem('user');
    const {data} = await axios.get(`${Env.API_URL}/profile-point/activityController/monthly`,
    {
      headers: {
        Authorization : `Bearer ${accessToken}`,
      },
    });
    return data;
  };
export const getAchivmentEntity = async () => {
    const {accessToken} = getItem('user');
    const {data} = await axios.get(`${Env.API_URL}/profile-point/activityController/entity`,
    {
      headers: {
        Authorization : `Bearer ${accessToken}`,
      },
    });
    return data;
  };
